import { useTranslation } from 'react-i18next'
import {
  ViewPortWarningStyledContainer,
  ViewPortWarningStyledCard,
  ViewPortWarningStyledIconContainer,
  ViewPortWarningStyledIconRelative,
  ViewPortWarningStyledIconBlur,
  ViewPortWarningStyledIconGradient,
  ViewPortWarningStyledHeading,
  ViewPortWarningStyledMessage,
  ViewPortWarningStyledInfoBox,
  ViewPortWarningStyledTextSection,
  ViewPortWarningStyledMonitor,
  ViewPortWarningStyledContent,
  ViewPortWarningStyledInfoContent,
  ViewPortWarningStyledInfoText,
  ViewPortWarningStyledDot,
} from '../styled'

function ViewportWarning() {
  const { t } = useTranslation()
  return (
    <ViewPortWarningStyledContainer>
      <ViewPortWarningStyledCard>
        <ViewPortWarningStyledIconContainer>
          <ViewPortWarningStyledIconRelative>
            <ViewPortWarningStyledIconBlur />
            <ViewPortWarningStyledIconGradient>
              <ViewPortWarningStyledMonitor strokeWidth={1.5} />
            </ViewPortWarningStyledIconGradient>
          </ViewPortWarningStyledIconRelative>
        </ViewPortWarningStyledIconContainer>

        <ViewPortWarningStyledContent>
          <ViewPortWarningStyledTextSection>
            <ViewPortWarningStyledHeading>
              {t('layout.viewportTooSmall')}
            </ViewPortWarningStyledHeading>
            <ViewPortWarningStyledMessage>
              {t('layout.useWiderScreen')}
            </ViewPortWarningStyledMessage>
          </ViewPortWarningStyledTextSection>

          <ViewPortWarningStyledInfoBox>
            <ViewPortWarningStyledInfoContent>
              <ViewPortWarningStyledDot />
              <ViewPortWarningStyledInfoText>
                {t('layout.minimumWidth')}
              </ViewPortWarningStyledInfoText>
              <ViewPortWarningStyledDot />
            </ViewPortWarningStyledInfoContent>
          </ViewPortWarningStyledInfoBox>
        </ViewPortWarningStyledContent>
      </ViewPortWarningStyledCard>
    </ViewPortWarningStyledContainer>
  )
}

export default ViewportWarning
